import Button, { ButtonIconPosition } from "@/components/shared/Button"
import { Icon, IconColor } from "@/components/shared/Icon"
import { getBatteryChargeIcon } from "@/utils/index"
import "./index.scss"

type WearableOptionDisconnectProps = {
   wearableId: string
   inmateId: string
   batteryPercentage?: number | null
   onClickDisconnect: (wearableId: string) => void
}

const WearableOptionDisconnect = ({
   wearableId,
   inmateId,
   batteryPercentage,
   onClickDisconnect,
}: WearableOptionDisconnectProps) => {
   return (
      <div className="wearable-option-disconnect">
         <div className="wearable-option-disconnect__header">
            <Icon
               name="unlinked"
               size="52"
               color={IconColor.HONOLULU_BLUE}
            />
            <div className="wearable-option-disconnect__title">
               <div className="wearable-option-disconnect__title-prefix">
                  Option 2
               </div>
               Disconnect
            </div>
         </div>
         <div className="wearable-option-disconnect__info">
            <div className="wearable-option-disconnect__info-group">
               <div className="wearable-option-disconnect__info-label">
                  Disconnect ReassureBand
               </div>
               <div className="wearable-option-disconnect__info-id">
                  {wearableId}
               </div>
               {batteryPercentage != null && (
                  <span className="wearable-option-disconnect__info-battery">
                     <Icon
                        name={getBatteryChargeIcon(batteryPercentage)}
                        color={IconColor.HONOLULU_BLUE}
                        size="16"
                     />
                     <span>{batteryPercentage}%</span>
                  </span>
               )}
            </div>
            <div className="wearable-option-disconnect__info-group">
               <div className="wearable-option-disconnect__info-label">
                  from inmate
               </div>
               <div className="wearable-option-disconnect__info-id">
                  {inmateId}
               </div>
            </div>
         </div>
         <div className="wearable-option-disconnect__button">
            <Button
               iconName="unlinked"
               iconPosition={ButtonIconPosition.LEFT}
               onClick={() => onClickDisconnect(wearableId)}
            >
               Disconnect ReassureBand
            </Button>
         </div>
      </div>
   )
}

export default WearableOptionDisconnect
